import { createSelector } from "@ngrx/store";
import { IAppState } from "../state/app.state";
import { IRequestsAndOperationsState } from "@edp-store/state/requests-and-operations.state";
import {
    IRequestsAndOperationsFilter,
    RequestsAndOperations,
    IInterventionDate
} from "@edp-models/requests-and-operations";
import { RequestsAndOperationsEnum } from "@edp-enums/requests-and-operations.enum";
import { Service } from "@edp-models/service.model";
import { INewRequestAndOperation } from "@edp-pages/requests-and-operations/services/new-request.service";

const requestsAndOperationsSelector = (state: IAppState) => state.requestsAndOperations;
const filtersSelector = (state: IAppState) => state.requestsAndOperations.filters;
const itemsSelector = (state: IAppState) => state.requestsAndOperations.requestsAndOperations;
const timeslotsSelector = (state: IAppState) => state.requestsAndOperations.availableTimeSlots.data;
const timeslotsErrorSelector = (state: IAppState) => state.requestsAndOperations.availableTimeSlots.lastAPIError;

export const getRequestsAndOperations = createSelector(
    requestsAndOperationsSelector,
    (state: IRequestsAndOperationsState) => state
);

export const getRequestsAndOperationsTimeSlots = createSelector(
    timeslotsSelector,
    (state: IInterventionDate[]) => state
);

export const getTimeSlotsError = createSelector(
    timeslotsErrorSelector,
    (state: Error) => state
);

export const requestsAndOperationsGetFilters = createSelector(
    getRequestsAndOperations,
    (state: {filters: IRequestsAndOperationsFilter[]}) => state.filters
);

export const requestsAndOperationsGetServices = createSelector(
    getRequestsAndOperations,
    (state: {services: Service[]}) => state.services
);

export const loadedServices = createSelector(
    (state: IAppState) => state.requestsAndOperations.loadedServices,
    (loadedServices: boolean) => loadedServices
);

export const loadedSlots = createSelector(
    (state: IAppState) => state.requestsAndOperations.loadedSlots,
    (loadedSlots: boolean) => loadedSlots
);

export const loadedRequestsAndOperations = createSelector(
    (state: IAppState) => state.requestsAndOperations.loadedRequestsAndOperations,
    (loadedRequestsAndOperations: boolean) => loadedRequestsAndOperations
);

export const associatedContract = createSelector(
    (state: IAppState) => state.requestsAndOperations.associatedContract,
    (associatedContract: number) => associatedContract
);

export const localSupportList = createSelector(
    (state: IAppState) => state.requestsAndOperations.localSupportList,
    (localSupportList: boolean) => localSupportList
);

export const getSelectedRequest = createSelector(
    (state: IAppState) => state.requestsAndOperations.selectedRequest,
    (request: RequestsAndOperations) => request
);

export const filteredRequestsAndOperations = createSelector(
    filtersSelector,
    itemsSelector,
    (filters: IRequestsAndOperationsFilter[], items: RequestsAndOperations[]) => {
        if (filters && items) {
            if (filters.length > 0) {
                let selectedFilter: number[] = [];
                const stateFilters = filters;

                stateFilters.forEach( filter => {
                    selectedFilter = (filter.options.some(opt => opt.selected) )
                        ? [...selectedFilter, filter.id] : [...selectedFilter];
                });

                if (selectedFilter.length === 0) {
                    return items;
                }
                const _serviceFiltered = selectedFilter.some(ftrId => ftrId === 1);
                const mainfilter = _serviceFiltered
                        ? stateFilters.find(el => el.id === 1)
                        : stateFilters.find(el => el.id === 2);
                const selectedOptions = mainfilter.options.filter(el => el.selected);


                items = items.filter(requestOperation => {
                    if (!!_serviceFiltered) {
                        return selectedOptions.find(el => el.acronym &&
                            (requestOperation.ServiceAcronym && el.acronym.toUpperCase() === requestOperation.ServiceAcronym.toUpperCase())
                            || (!requestOperation.ServiceAcronym && el.acronym.toUpperCase() === RequestsAndOperationsEnum.GENERAL));
                    } else {
                        return selectedOptions.find(el => !el.statusCode
                            ? el.name === requestOperation.Status
                            : el.statusCode.includes(requestOperation.Status.replace("pt.edp.edponline.support.help.", "")));
                    }
                });
                return items;
            }
        } else {
            return null;
        }
    }
);

export const getSelectedServiceAndMotive = createSelector(
    (state: IAppState) => state.requestsAndOperations.selectedServiceAndMotive,
    (request: INewRequestAndOperation) => request
);

export const getNewRequestStatus = createSelector(
    (state: IAppState) => state.requestsAndOperations.newRequestStatus,
    (request: any) => request
);
